import useCurrency from "../hooks/useCurrency"

const OUTER_RADIUS = {
    md: 'ltr:rounded-r-md rtl:rounded-l-md',
    '2xl': 'ltr:rounded-r-2xl rtl:rounded-l-2xl'
} as const;

type CurrencyInputRightProps = {
    useAppCurrency?: boolean;
    code?: string;
    radius?: keyof typeof OUTER_RADIUS;
    title?: string;
};

export default function CurrencyInputRight({ useAppCurrency = false, code, radius = 'md', title }: CurrencyInputRightProps) {
    const { baseCurrency, currency } = useCurrency();
    return (
        <div
            title={title}
            className={`bg-[#eee] flex justify-center items-center ${OUTER_RADIUS[radius]} px-3 font-semibold border ltr:border-l-0 rtl:border-r-0 border-white-light dark:border-[#17263c] dark:bg-[#1b2e4b]`}
        >
            {code ?? (useAppCurrency ? currency?.symbol : baseCurrency?.symbol)}
        </div>
    )
}
